interface SectionTitleProps {
  eyebrow: string;
  title: string;
  desc?: string;
}

export default function SectionTitle({ eyebrow, title, desc }: SectionTitleProps) {
  return (
    <div className="mb-8 md:mb-10">
      <p className="eyebrow">
        <i className="ri-flashlight-fill text-sm"></i>
        {eyebrow}
      </p>
      <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && (
        <p className="mt-3 max-w-2xl text-sm leading-6 text-foreground-600 md:text-base">
          {desc}
        </p>
      )}
    </div>
  );
}